// Shared provider brand marks — used on the Connected Accounts UI
// (Settings / Workspace) and on the login/signup page's "Continue with..."
// buttons, so both read at a glance the same way any standard
// "Sign in with Google/Microsoft" button does. Plain inline SVG, no
// external image requests.
export function GoogleLogo({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true" style={{ flexShrink: 0 }}>
      <path fill="#4285F4" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.5-5.9 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.1 8 3l5.7-5.7C34.6 6 29.6 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20c11 0 19.5-8 19.5-19.5 0-1.3-.1-2.3-.4-4z"/>
      <path fill="#34A853" d="M6.3 14.7l6.6 4.8C14.6 15.9 18.9 13 24 13c3.1 0 5.8 1.1 8 3l5.7-5.7C34.6 6 29.6 4 24 4c-7.3 0-13.6 4.1-16.7 10.1z"/>
      <path fill="#FBBC05" d="M24 44c5.5 0 10.4-1.9 14.3-5.1l-6.6-5.6C29.6 35.1 26.9 36 24 36c-5.3 0-9.7-3.4-11.3-8.1l-6.6 5.1C9.6 39.6 16.2 44 24 44z"/>
      <path fill="#EA4335" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4 5.5l6.6 5.6C41.6 35.7 44 30.4 44 24c0-1.3-.1-2.3-.4-3.5z"/>
    </svg>
  );
}
export function MicrosoftLogo({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 21 21" aria-hidden="true" style={{ flexShrink: 0 }}>
      <rect x="1" y="1" width="9" height="9" fill="#F25022"/>
      <rect x="11" y="1" width="9" height="9" fill="#7FBA00"/>
      <rect x="1" y="11" width="9" height="9" fill="#00A4EF"/>
      <rect x="11" y="11" width="9" height="9" fill="#FFB900"/>
    </svg>
  );
}
export function YahooLogo({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{ flexShrink: 0 }}>
      <circle cx="12" cy="12" r="12" fill="#5F01D1"/>
      <text x="12" y="16.5" textAnchor="middle" fontSize="11" fontWeight="700" fill="#fff" fontFamily="Arial,Helvetica,sans-serif">Y!</text>
    </svg>
  );
}
export function MailLogo({ size = 16, color = "#8890B0" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flexShrink: 0 }}>
      <rect x="3" y="5" width="18" height="14" rx="2"/>
      <path d="M3 7l9 6 9-6"/>
    </svg>
  );
}
// Best-guess logo for a connected account row, from its provider (OAuth
// accounts) or its SMTP host (falls back to a plain envelope for anything
// that isn't a recognized consumer provider).
export function accountLogo(a, size = 20) {
  if (a.provider === "google") return <GoogleLogo size={size}/>;
  if (a.provider === "microsoft") return <MicrosoftLogo size={size}/>;
  const h = (a.host || "").toLowerCase();
  if (h.includes("gmail")) return <GoogleLogo size={size}/>;
  if (h.includes("office365") || h.includes("outlook")) return <MicrosoftLogo size={size}/>;
  if (h.includes("yahoo")) return <YahooLogo size={size}/>;
  return <MailLogo size={size}/>;
}
